<template>
  <b-sidebar
      :ref="itemId"
      :id="itemId"
      :title="sidebarTitle"
      :width="width"
      :right="right"
      :backdrop-variant="backdropVariant"
      :backdrop="backdrop"
      :shadow="shadow"
      :no-header="noHeader"
      centered
      @change="handleSidebarChange"
  >
    <div
        id="sidebar"
    >
        <b-tabs
            :pills="tabs.isPills"
            :small="tabs.isSmall"
            :justified="tabs.isJustified"
            :isFill="tabs.isFill"
            :end="tabs.isEnd"
            :vertical="tabs.isVertical"
            content-class="mt-3"
            defaultActiveKey="stage"
            nav-wrapper-class="sticky-top bg-light"
            card
        >
          <b-tab
              v-for="(aSection, index) in availSections"
              :key="index"
              :title="aSection.title"
          >
            <template #title>
              <h6 style="padding-top: 25px;">
                <b-icon
                    v-if="aSection.icon"
                    :icon="aSection.icon"
                    aria-hidden="true"
                />
                {{ aSection.title }}
              </h6>
            </template>
            <vue-custom-scrollbar class="scroll-area"  :settings="settings" @ps-scroll-y="scrollHandle">
            <component
                :is="aSection.component"
                v-bind="Object.assign({}, { ...propsData, info: aSection.info })"
                :ref="aSection.componentName"
                @input-answer="handleInputAnswer"
                @update-provider="handleUpdateProvider"
            />
            </vue-custom-scrollbar>
          </b-tab>
        </b-tabs>
    </div>
  </b-sidebar>
</template>

<script>
import CloseButton from "@/components/common/closeButton";
import BasicInfo from "./basicInfo";
import Crew from "./crew";
import Social from "./socials";
import FAQs from "./faqs";
import Services from "./services";
import MyApps from "./myapps";
import Site from "./site";
import Automations from "./crew";
import Resources from "./crew";
import VueCustomScrollbar from 'vue-custom-scrollbar';
import "vue-custom-scrollbar/dist/vueScrollbar.css";

import axios from "axios";
export default {
  name: "AddEditItem_Providers_SideBar",
  components: {
    CloseButton,
    VueCustomScrollbar
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    itemId: {
      type: String,
      default: "add-edit-item"
    }
  },
  computed: {
    formData() {
      return this.entity && this.entity.form ? this.entity.form : null;
    },
    availSections() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    },
    propsData() {
      return {
        profile: this.profile,
        provider: this.providerData
      };
    }
  },
  created() {},
  mounted() {  },
  methods: {
    scrollHandle(evt) {
      console.log(evt);
    },
    handleUpdateItem(providerData) {
      this.isUpdate = true;
      this.providerData = _.clone(providerData);
      this.$root.$emit("bv::toggle::collapse", this.itemId);
    },
    handleCloseBtnClick() {
      this.entity = null;
      this.$bvModal.hide(this.itemId);
    },
    handleUpdateProvider(payload) {
         axios.get("https://api.ipify.org?format=json").then(res => {
        payload.ip = res.data.ip;
        this.$store
          .dispatch("admin/updateProvider", payload)
          .then(res => {
            //Item Updated
            this.$store.dispatch("user/showNotification", {
              title: `Provider Updated'}`,
              description: `Provider Updated`,
              variant: "success"
            });

            this.$emit("provider-updated");
          });
      });
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    handleSidebarChange(){},
    handleInputAnswer(){}
  },
  data() {
    return {
      settings: {
        suppressScrollY: false,
        suppressScrollX: true,
        wheelPropagation: false
      },
      isUpdate: false,
      providerData: null,
      entity: null,
      //Sidebar
      right: true,
      shadow: true,
      backdrop: true,
      backdropVariant: 'dark',
      width: "50%",
      sidebarTitle:"test",
      noHeader: true,
      tabs: {
        isPills: false,
        isSmall: true,
        isJustified: true,
        isFill: true,
        isEnd: false,
        isVertical: false
      },
      tab: {
        titleLinkAttributes: {
          color: "#5695e0"
        },
        hexColorTabBg: "#777",
        hexColorTabText: "#777",
        hexColorScreen: "#777"
      },
      sections: [
        {
          id: "basic",
          title: "Basic Info",
          component: BasicInfo,
          componentName: "BasicInfo",
          avail: true
        },
        {
          id: "crew",
          title: "Crew",
          component: Crew,
          componentName: "Crew",
          avail: true
        },
        {
          id: "social", //billings, invoices
          title: "Social",
          component: Social,
          componentName: "Social",
          avail: true
        },
        {
          id: "faqs", //billings, invoices
          title: "FAQs",
          component: FAQs,
          componentName: "FAQs",
          avail: true
        },
        {
          id: "services", //billings, invoices
          title: "Services",
          component: Services,
          componentName: "Services",
          avail: true
        },
        {
          id: "myapps",
          title: "MyApps",
          component: MyApps,
          componentName: "MyApps",
          avail: true
        },
        {
          id: "site", //billings, invoices
          title: "Site",
          component: Site,
          componentName: "Site",
          avail: true
        },
        {
          id: "billing", //billings, invoices
          title: "Billing",
          component: Crew,
          componentName: "Crew",
          avail: false
        },
        {
          id: "connects",
          title: "Connections",
          component: BasicInfo,
          componentName: "BasicInfo",
          avail: false
        },
        {
          id: "insights",
          title: "Insights",
          component: BasicInfo,
          componentName: "BasicInfo",
          avail: false
        },
        {
          id: "sessions",
          title: "Sessions",
          component: BasicInfo,
          componentName: "BasicInfo",
          avail: false
        },
        {
          id: "automations",
          title: "Automations",
          component: BasicInfo,
          componentName: "BasicInfo",
          avail: false
        },
        {
          id: "resources",
          title: "Resources",
          component: BasicInfo,
          componentName: "BasicInfo",
          avail: false
        }
      ],
    };
  }
};
</script>

<style lang="scss" scoped>
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 90vh;
}
.status-box {
  background-color: #a9a6a6;
  border-radius: 15px;
  padding: 10px;
  margin: 15px;
}
</style>
